import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const VerifiedOutline = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M7.77004 11.4201L10.09 13.7501L15.95 7.87006L17.43 9.36006L10.09 16.7201L6.29004 12.9101L7.77004 11.4201Z"
        {...mergedPathProps}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.56 9.2L23 11.99L20.56 14.79L20.9 18.48L17.29 19.3L15.4 22.49L12 21.03L8.6 22.5L6.71 19.3L3.1 18.48L3.44 14.78L1 11.99L3.44 9.2L3.1 5.5L6.71 4.69L8.6 1.5L12 2.96L15.4 1.5L17.29 4.69L20.9 5.51L20.56 9.2ZM18.49 14.12L19.05 13.47L20.33 11.99L19.04 10.52L18.48 9.87L18.56 9.02L18.74 7.07L16 6.45L15.56 5.71L14.57 4.03L12.79 4.8L12 5.14L11.2 4.8L9.42 4.03L8.43 5.71L7.99 6.45L5.25 7.07L5.43 9.01L5.52 9.87L4.96 10.52L3.67 12L4.96 13.47L5.52 14.12L5.44 14.97L5.26 16.93L8 17.55L8.44 18.29L9.43 19.96L11.21 19.19L12 18.85L12.8 19.19L14.58 19.96L15.57 18.28L16.01 17.54L18.75 16.92L18.57 14.97L18.49 14.12Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default VerifiedOutline;
